<template>
  <div>
    <div class="aps-page_content-table">
      <el-table
        :data="singleStoreData"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column
          align="center"
          :label="$t('devices.inventory.storeName')"
          prop="storeName"
          width="140"
        >
          <el-table-column min-width="140" align="center" prop="storeName">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="pageParams.storeName"
                @input="getSingleStoreList"
                size="small"
                clearable
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.total')"
          width="105"
        >
          <el-table-column min-width="140" align="center" prop="total">
            <template slot="header" slot-scope="scope"></template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.normals')"
          width="105"
        >
          <el-table-column min-width="140" align="center" prop="normals">
          </el-table-column>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.idles')"
          width="95"
        >
          <el-table-column min-width="140" align="center" prop="idles">
            <template
              slot="header"
              slot-scope="scope"
            ></template> </el-table-column
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.repairs')"
          width="95"
        >
          <el-table-column min-width="140" align="center" prop="scraps">
            <template slot="header" slot-scope="scope"></template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.factories')"
          width="95"
        >
          <el-table-column min-width="140" align="center" prop="factories">
            <template slot="header" slot-scope="factories"></template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.postRegisters')"
        >
          <el-table-column min-width="140" align="center" prop="postRegisters">
            <template slot="header" slot-scope="scope"></template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.problems')"
          prop="problems"
          ><el-table-column min-width="160" align="center" prop="problems">
            <template
              slot="header"
              slot-scope="scope"
            ></template> </el-table-column
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.note')"
          prop="note"
          ><el-table-column min-width="140" align="center" prop="note">
            <template
              slot="header"
              slot-scope="scope"
            ></template> </el-table-column
        ></el-table-column>
        <el-table-column
          width="110"
          align="center"
          :label="$t('devices.inventory.action')"
          fixed="right"
        >
          <el-table-column min-width="140" align="center" prop="storeName">
            <template slot="header" slot-scope="scope"></template>
            <template slot-scope="{ row }">
              <el-button
                icon="el-icon-search"
                style="color: rgb(96, 98, 102)"
                type="text"
                @click="checkSingleData(row)"
                :title="$t('devices.inventory.check')"
              ></el-button>
              <el-button
                style="color: rgb(96, 98, 102)"
                icon="el-icon-download"
                type="text"
                :title="$t('devices.inventory.export')"
                @click="exportSingleExcel(row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <pagination :tableInfo="pageParams" @changePage="changePage" />
    </div>

    <h5 class="summaryTitle">{{ $t("devices.inventory.in all") }}</h5>
    <div class="aps-page_content-table">
      <el-table :data="summaryData" style="width: 100%; margin-bottom: 20px">
        <el-table-column
          align="center"
          prop="stores"
          :label="$t('devices.inventory.storeNum')"
          width="90"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.total')"
          prop="total"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.normals')"
          prop="normals"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.idles')"
          width="95"
          prop="idles"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.repairs')"
          width="95"
          prop="repairs"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.factories')"
          width="95"
          prop="factories"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="postRegisters"
          :label="$t('devices.inventory.postRegisters')"
        >
        </el-table-column>

        <el-table-column
          align="center"
          :label="$t('devices.inventory.problems')"
          prop="problems"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('devices.inventory.action')"
          width="110"
        >
          <template>
            <el-button
              style="color: rgb(96, 98, 102)"
              icon="el-icon-download"
              type="text"
              :title="$t('devices.inventory.export')"
              @click="exportSummaryExcel()"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 查看明细 -->
    <el-dialog
      :title="$t('devices.inventory.Inventory details')"
      :visible.sync="isVisibleDetailDialog"
      class="communication-records_dialog"
      width="90%"
      :close-on-click-modal="false"
      append-to-body
    >
      <inventory-detail
        ref="checkDetailWrap"
        :clickRow="clickRow"
      ></inventory-detail>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="isVisibleDetailDialog = false"
          >{{ $t("devices.cancel") }}</el-button
        >
        <el-button
          class="save-btn btn"
          size="small"
          @click="isVisibleDetailDialog = false"
          type="primary"
          >{{ $t("devices.ok") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import InventoryDetail from "./InventoryDetail.vue";
import {
  inventoryInfoList,
  inventorySummary,
  exportSummary,
  exportItem,
} from "@/libs/api/inventory";
export default {
  props: {
    currentRow: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  components: {
    pagination,
    InventoryDetail,
  },
  data() {
    return {
      singleStoreData: [],
      summaryData: [],
      pageParams: {
        // batchId: this.currentRow.batchId,
        storeId: "",
        storeName: "",
        current: 1,
        size: 10,
        total: 0,
      },
      isVisibleDetailDialog: false,
      clickRow: {},
    };
  },
  watch: {
    currentRow: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        this.getSingleStoreList();
        this.getSummary();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  mounted() {
    console.log(this.currentRow, "mmmmm");
    this.getSummary();
    this.getSingleStoreList();
  },
  methods: {
    changePage() {
      this.getSingleStoreList();
    },
    // 获取单个门店报告列表
    getSingleStoreList() {
      let params = {
        batchId: this.currentRow.batchId,
        ...this.pageParams,
      };
      inventoryInfoList(params).then((res) => {
        console.log(res);
        this.singleStoreData = res.data.data.records;
        this.pageParams.total = res.data.data.total;
      });
    },
    checkSingleData(row) {
      console.log(123);
      console.log(row);
      this.clickRow = row;
      this.isVisibleDetailDialog = true;
      // 查看单个门店明细
    },
    exportSingleExcel(row) {
      const params = {
        id: row.id,
      };
      let fileName =
        this.currentRow.name +
        "-" +
        this.currentRow.storeName +
        this.$t("devices.inventory.report") +
        "-" +
        Date.now();
      // 导出单个门店数据
      exportItem(params).then((res) => {
        console.log(res);
        const { data } = res;
        let downfile;
        downfile = new File([data], `${fileName}.xlsx`, {
          type: "application/vnd.ms-excel",
        });
        const tmpLink = document.createElement("a");
        const objectUrl = URL.createObjectURL(downfile);

        tmpLink.href = objectUrl;
        tmpLink.download = downfile.name;
        document.body.appendChild(tmpLink);
        tmpLink.click();

        document.body.removeChild(tmpLink);
        URL.revokeObjectURL(objectUrl);
      });
    },

    // 获取总计信息
    getSummary() {
      const params = {
        batchId: this.currentRow.batchId,
      };
      inventorySummary(params).then((res) => {
        console.log(res);
        this.summaryData = [res.data.data];
      });
    },

    // 导出汇总数据
    exportSummaryExcel() {
      const params = {
        batchId: this.currentRow.batchId,
      };
      let fileName =
        this.currentRow.name +
        this.$t("devices.inventory.report") +
        "-" +
        Date.now();
      exportSummary(params).then((res) => {
        console.log(res);
        const { data } = res;
        let downfile;
        downfile = new File([data], `${fileName}.xlsx`, {
          type: "application/vnd.ms-excel",
        });
        const tmpLink = document.createElement("a");
        const objectUrl = URL.createObjectURL(downfile);

        tmpLink.href = objectUrl;
        tmpLink.download = downfile.name;
        document.body.appendChild(tmpLink);
        tmpLink.click();

        document.body.removeChild(tmpLink);
        URL.revokeObjectURL(objectUrl);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.summaryTitle {
  margin: 40px 0 20px;
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 110px;
    height: 40px;
    border: none;
  }
  .el-button.cancel-btn {
    background: #d4d4d4 !important;
    box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
    color: #626262;
  }
  .el-button.save-btn {
    background: #35b871 !important;
    box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
    color: #ffffff;
  }
}
</style>
